import Vue from "vue";
import VueI18n from "vue-i18n";

import getBrowserLocale from "@/util/i18n/getBrowserLocale";
import supportedLocales from "./util/i18n/supported-locales";
import dateTimeFormats from "@/locales/_date-time-formats";
import numberFormats from "@/locales/_number-formats";

Vue.use(VueI18n);

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true });
  if (supportedLocalesInclude(browserLocale)) {
    console.log("browserLocale="+browserLocale+", starting locale=" + browserLocale);
    return browserLocale;
  } else {
    console.log("browserLocale="+browserLocale+", starting locale=" + (process.env.VUE_APP_I18N_LOCALE || "en"));
    return process.env.VUE_APP_I18N_LOCALE || "en";
  }
}

function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}

const startingLocale = getStartingLocale();

const i18n = new VueI18n({
  locale: startingLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {},
  dateTimeFormats,
  numberFormats
});

const loadedLanguages = [];

export function loadLocaleMessagesAsync(locale) {
  if (loadedLanguages.length > 0 && i18n.locale === locale) {
    return Promise.resolve(locale);
  }

  // If the language was already loaded
  if (loadedLanguages.includes(locale)) {
    i18n.locale = locale;
    return Promise.resolve(locale);
  }

  if (!supportedLocalesInclude(locale)) {
    return Promise.resolve("en");
  }

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: "locale-[request]" */ `@/locales/${locale}.json`
  ).then(messages => {
    i18n.setLocaleMessage(locale, messages.default);
    loadedLanguages.push(locale);
    i18n.locale = locale;
    return Promise.resolve(locale);
  });
}

loadLocaleMessagesAsync(startingLocale);

export default i18n;
